<template>
  <div class=" copyright">
    <div class="screen-container">
      <div class="cnt">
        <img
          src="../../assets/img/copyright/logo.png"
          alt=""
          srcset=""
          class="logo"
        />

        <div class="policy-t">
          <a
            href="https://www.v-brick.com.tw/tosandprivacy2023/"
            target="_blank"
            class="p-txt"
          >
            <img src="../../assets/img/copyright/policy.png" alt="" srcset="" />
          </a>
          <a
            href="https://www.v-brick.com.tw/privacy-policy2023/"
            target="_blank"
            class="p-txt"
          >
            <img
              src="../../assets/img/copyright/private.png"
              alt=""
              srcset=""
            />
          </a>
        </div>
        <img
          src="../../assets/img/copyright/txt.png"
          alt=""
          srcset=""
          class="txt"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.copyright {
  background: #f2ffdd;
  width: 100%;
  height: 190px;
  .screen-container {
    width: calc(100% - 250px);
  }
  .cnt {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2vw;
  }
  .logo {
    width: 450px;
    height: auto;
  }
  .p-txt {
    width: 128px;
    height: 47px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .txt {
    width: 916px;
    height: autopx;
  }
  .policy-t {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    height: 95px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/copyright.vue